export const GENERAL_PROMPT_REQUEST = "GENERAL_PROMPT_REQUEST";
export const GENERAL_PROMPT_SUCCESS = "GENERAL_PROMPT_SUCCESS";
export const GENERAL_PROMPT_FAILURE = "GENERAL_PROMPT_FAILURE";


export const GENERAL_PROMPT_GET_REQUEST = "GENERAL_PROMPT_GET_REQUEST";
export const GENERAL_PROMPT_GET_SUCCESS = "GENERAL_PROMPT_GET_SUCCESS";
export const GENERAL_PROMPT_GET_FAILURE = "GENERAL_PROMPT_GET_FAILURE";
